import { render, staticRenderFns } from "./PresentationDetailsOtherInformation.vue?vue&type=template&id=61194f9e"
import script from "./PresentationDetailsOtherInformation.vue?vue&type=script&lang=ts"
export * from "./PresentationDetailsOtherInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports